document.addEventListener('DOMContentLoaded', function() {
    const inputsAndTextareas = document.querySelectorAll('.ginput_container input[type="text"], .ginput_container input[type="email"], .ginput_container input[type="number"], .ginput_container input[type="tel"], .ginput_container textarea, .form-row input[type="text"], .form-row input[type="email"], .form-row input[type="number"], .form-row input[type="tel"], .form-row textarea');

    inputsAndTextareas.forEach(element => {
        const parentGfield = element.closest('.gfield, .form-row');
        const label = parentGfield.querySelector('label');

        if (element.value) {
            label.classList.add('has-value');
        } else {
            label.classList.remove('has-value');
        }
        element.addEventListener('input', function() {
            if (element.value) {
                label.classList.add('has-value');
            } else {
                label.classList.remove('has-value');
            }
        });
    });
});
//# sourceMappingURL=input-focus.js.map
